import React, { useEffect } from 'react';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import { useStyles } from '../UrbanSportsConnect/ConnectUrbanSports.styles';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { ThirdPartySetup } from '../Card/ThirdPartySetup/ThirdPartySetup';
import { MappingCategories } from '../Card/CategoriesCard';
import { useRequestChannels } from '~/requests/adapterSvc/useRequestChannels';
import { useProvider } from '~/Hooks';
import { useRequestChannelById } from '~/requests/adapterSvc/useRequestChannelById';
import { IntegrationTypes } from '~/Models/DTO/IntegrationChannels.model';
export const ModifyIntegration = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const { integration: integrationType } = useParams<{ integration: string }>();

  const { classes } = useStyles();
  const { t } = useTranslation();

  const { currentProvider } = useProvider();
  const providerUUID = currentProvider?.uuid as string;

  const { data: integrations } = useRequestChannels({ providerId: providerUUID });
  const { data: channel } = useRequestChannelById({ channelId: id });

  const determineTitle = () => {
    switch (integrationType) {
      case IntegrationTypes.Magicline:
        return t('magicline.integration');
      case IntegrationTypes.Eversports:
        return t('eversports.integration');
      case IntegrationTypes.Virtuagym:
        return t('virtuagym.integration');
      case IntegrationTypes.Zingfit:
        return t('zingfit.integration');
      case IntegrationTypes.VirtuagymV1:
        return t('virtuagym.integration');
      case IntegrationTypes.Mindbody:
        return t('mindbody.integration');
      case IntegrationTypes.Resamania:
        return t('resamania.integration');
      default:
        return '';
    }
  };

  useEffect(() => {
    const handleNavigation = (id: string) => {
      if (id === 'new') {
        return;
      } else if (integrations && integrations.data !== undefined) {
        const isIdValid = integrations.data.some((item) => item.id === id);

        if (!isIdValid) {
          history.push('/provider');
        }
      }
    };

    if (id) {
      handleNavigation(id);
    }
  }, [id, integrations]);

  return (
    <PrivateLayout title={determineTitle()}>
      <div className={classes.container}>
        <ThirdPartySetup
          channel={channel?.data}
          mode={id === 'new' ? 'new' : 'edit'}
          id={id}
          integrationType={integrationType}
        />
        <MappingCategories id={id} />
      </div>
    </PrivateLayout>
  );
};
